// /TopBorrowers/state/reducer.js
import { IS_LOADING, SUCCESS, HAS_ERROR } from "./actions";

export const initialState = {
  isLoading: false,
  hasError: false,
  data: { hits: [], total: 0 },
  error: null,
};

const topBorrowersReducer = (state = initialState, action) => {
  switch (action.type) {
    case IS_LOADING:
      return {
        ...state,
        isLoading: true,
        hasError: false,
        error: null,
      };

    case SUCCESS:
      return {
        ...state,
        isLoading: false,
        data: action.payload || { hits: [], total: 0 },
        error: null,
        hasError: false,
      };

    case HAS_ERROR:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
        hasError: true,
        // Keep existing data on error, don't reset it
      };

    default:
      return state;
  }
};

export default topBorrowersReducer;
